export default __webpack_public_path__ + "static/assets/1a32a1c8e83e52c77ca1e23c717a9401.jpg";